var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "-56 0 480 480",
    width: "480pt",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m224 288v-72h-48v-24c0-22.398438-17.601562-40-40-40s-40 17.601562-40 40v24h-48v224h96v-16h-80v-192h32v16h16v-16h48v16h16v-16h32v56zm-64-72h-48v-24c0-13.601562 10.398438-24 24-24s24 10.398438 24 24zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m312 464h-288c-4.800781 0-8-3.199219-8-8v-432c0-4.800781 3.199219-8 8-8h232v48c0 13.601562 10.398438 24 24 24h16v-16h-16c-4.800781 0-8-3.199219-8-8v-35.199219l48 53.597657v205.601562h16v-211.199219l-68.800781-76.800781h-243.199219c-13.601562 0-24 10.398438-24 24v432c0 13.601562 10.398438 24 24 24h288c13.601562 0 24-10.398438 24-24h-16c0 4.800781-3.199219 8-8 8zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m112 40h88v16h-88zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m48 80h168v16h-168zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m48 120h240v16h-240zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m200 160h88v16h-88zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m240 200h48v16h-48zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m240 240h48v16h-48zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m48 160h32v16h-32zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m192 368h40v16h-40zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m192 392h24v16h-24zm0 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m344 304h-160c-13.601562 0-24 10.398438-24 24v88c0 13.601562 10.398438 24 24 24h160c13.601562 0 24-10.398438 24-24v-88c0-13.601562-10.398438-24-24-24zm8 112c0 4.800781-3.199219 8-8 8h-160c-4.800781 0-8-3.199219-8-8v-64h176zm0-80h-176v-8c0-4.800781 3.199219-8 8-8h160c4.800781 0 8 3.199219 8 8zm0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerm);
export default __webpack_public_path__ + "static/media/term.3b345069736f5be9db18da557c723178.svg";
export { ForwardRef as ReactComponent };